import { Box, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import BaseButton from "../../BaseButton";

export default function ResetPasswordConfirmModal({ close }) {
  const navigate = useNavigate()

  return (
    <Box sx={{
      maxWidth: '496px',
      borderRadius: '8px',
      boxShadow: '0px 2px 10px 0px #5B87EF33',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      background: 'white',
      padding: '40px',
      position: 'relative'
    }}>
      <CloseIcon 
        sx={{
          position: 'absolute',
          right: '10px',
          top: '10px',
          color: 'primary.mediumGray',
          fontSize: '32px',
          cursor: 'pointer'
        }}
        onClick={close}
      />
      <Stack
        direction={'column'}
        spacing={'32px'}
      >
        <Typography variant="h2">
          Your password has been reset!
        </Typography>
        <Box sx={{
          width: '100%'
        }}>
          <BaseButton
            buttonType="primary"
            onClick={() => {
              navigate('/login')
              close()
            }}
          >
            Sign in with new password
          </BaseButton>
        </Box>
      </Stack>
    </Box>
  )
}